const en = {
  nav: { historia: "Story", carta: "Menu", vision: "Vision", servicios: "Other services", galeria: "Gallery", mapa: "Site map", cta: "Request information" },
  services: { cumpleanos: "Birthdays", fiestas: "Private parties", reservas: "Venue bookings", info: "General information" },
  hero: {
    eyebrow: "Signature cuisine · Premium cocktails · Since forever",
    l1: "El gato", l2: "con copas",
    claim: "It's not a night. It's an experience.",
    sub: "The bar we've always had, the one for our people. We met here, it all began here, and we're still mixing the antidote: good cocktails, better company and nights that never repeat.",
    cta: "Book your night", cta2: "See the menu", badge: "Nine lives, one night",
  },
  marquee: ["It's not a night, it's an experience", "The bar we've always had", "Signature cocktails", "Where it all began", "Birthdays", "Private parties", "Book the venue", "Nine lives, a thousand drinks"],
  historia: {
    eyebrow: "Our story",
    title: "Where the red thread began",
    lead: "Every good story has a bar. Ours has this one.",
    scenes: [
      { y: "2022", t: "Two lives, a bar still to come", d: "He came from Mediterranean hospitality and tourism, long seasons behind the bar. She came from numbers, business and logistics, looking for something that truly fulfilled her. Separate paths, one shared spark: creativity." },
      { y: "2023", t: "The red thread", d: "One ordinary night, at this very bar, fate crossed our paths. We met here. Between drinks and conversation we began weaving a red thread that, without knowing it, would become the foundation of everything that followed." },
      { y: "2023–2024", t: "The recipe", d: "We kept coming back without planning to, because this was our place. And here, between laughs and the bar, we found the antidote: good people, a well-made drink, music that sticks and no rush to leave. The recipe for our happiness. #PICHONTEAM and the first brands we built together were born from those nights." },
      { y: "2025", t: "The double somersault", d: "We reinvented ourselves from top to bottom and became partners in a shared project. It wasn't easy, but it made us stronger. We're still in the trade and still toasting here." },
      { y: "2026", t: "The bar we've always had, finally out loud", d: "Today El gato con copas is part of the #PICHONTEAM family, alongside La Patrona. It's not a new line: it's the same one as always. We're opening the door so you can find your antidote too." },
    ],
    quote: "We don't come here for a drink. We come here to stay.",
    signature: "— The usual crew, from behind the cat's bar",
    wink: "La Patrona says «It's not just an event, it's an experience». At the cat we bring it to every night.",
  },
  carta: {
    eyebrow: "The menu",
    title: "A tale in four chapters",
    intro: "Every night reads differently, but the tale always starts the same way: something tasty to share and a well-made drink. Pick a chapter.",
    chapters: {
      "primeras-lineas": "Something to nibble while the rest arrives. The dishes every good story starts with.",
      sirena: "What comes from the sea, fresh and unhurried. For those who go with the tide.",
      cazador: "Flavours of the land, full of character. For those who go all in.",
      postres: "The sweet ending. Because every good night deserves a happy ending.",
    },
    note: "Ask at the bar for the house antidote. It changes every night, as it should.",
  },
  vision: {
    eyebrow: "Vision", title: "Where the cat is purring next", items: [
      { t: "The bar we've always had", d: "The place you come back to without planning, because you know there'll be a familiar face at the bar." },
      { t: "Cocktails, no fuss", d: "Serious bar technique, served like old friends." },
      { t: "Tropical spirit", d: "Plants, colour and music to escape without leaving the city." },
      { t: "Every night, an experience", d: "No night repeats. Every celebration is unique and every guest, one more chapter of the story." },
    ],
  },
  servicios: {
    eyebrow: "Your night, your way",
    title: "You bring the reason. We bring the experience.",
    intro: "Open each option and tell us what you have in mind.",
    items: {
      cumpleanos: "Another year deserves a night to remember. Reserved area, cocktails for the group and the music you feel like. You just blow out the candles.",
      fiestas: "Farewells, anniversaries, company dinners or just because. We design the night with you: menu, drinks, atmosphere and every last detail.",
      reservas: "The whole bar for your people. Just like home, but with the best bar in town.",
    },
    buttons: { cumpleanos: "I want my birthday here", fiestas: "Design my party", reservas: "Book the venue" },
  },
  galeria: {
    eyebrow: "Gallery",
    title: "Real nights, people of the house",
    intro: "No photo repeats, because no night repeats. These are some of the lives the cat has already lived.",
  },
  form: {
    eyebrow: "Book your night", title: "Tell us your plan",
    intro: "Tell us what you're celebrating and we'll make it an experience. We reply within 24 hours. In a hurry? Message us on WhatsApp.",
    name: "Full name", email: "Email", phone: "Phone", service: "What are we celebrating?", date: "Preferred date", guests: "Guests", message: "Message",
    messagePh: "Tell us about your ideal night…", choose: "Choose an option",
    options: { cumpleanos: "Birthday", fiestas: "Private party", reservas: "Book the venue", info: "I just want information" },
    submit: "I want my experience", sending: "Sending...",
    ok: "Got it! The cat is already preparing your night. We'll write to you within 24 hours.",
    err: "Couldn't send. Try again or message us on WhatsApp.",
  },
  mapa: { eyebrow: "Web architecture", title: "Site map, ready for SEO", intro: "Hierarchical structure of the site to optimise crawling and indexing. Hover each node to see its URL and schema." },
  footer: { tagline: "Every night, an experience.", explore: "Explore", partners: "The family", hours: "[Opening hours]", rights: "All rights reserved.", design: "Design & strategy", patrona: "Events" },
  whatsapp: "Hi, I'd like more information about El gato con copas.",
};

export default en;
